import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "row no-gutters" };
const _hoisted_2 = { class: "col-12 font7-responsive border-bottom pt-1 pb-4" };
const _hoisted_3 = { class: "mb-2" };
const _hoisted_4 = {
    class: "mb-3 ml-n1",
    style: { "max-width": "240px" }
};
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 1,
    class: "mb-0 fc-brand_red_hover"
};
const _hoisted_7 = {
    key: 2,
    class: "mb-0"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d;
    const _component_trustami_widget = _resolveComponent("trustami-widget");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_chip = _resolveComponent("v-chip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, "Artikelnummer: " + _toDisplayString((_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.cArtNr), 1),
            _createElementVNode("div", _hoisted_4, [
                false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
                            _createTextVNode(" class=\"trustpilot-widget\" data-locale=\"de-DE\" data-template-id=\"5419b637fa0340045cd0c936\" data-businessunit-id=\"5de8f7e831cfbb00014033b8\" data-style-height=\"20px\" data-style-width=\"100%\"> ", -1),
                            _createElementVNode("a", {
                                href: "https://de.trustpilot.com/review/myswooop.de",
                                target: "_blank",
                                rel: "noopener"
                            }, "Trustpilot", -1)
                        ]))]))
                    : _createCommentVNode("", true),
                _createVNode(_component_trustami_widget, { appearance: "small" })
            ]),
            (((_b = _ctx.currentProduct) === null || _b === void 0 ? void 0 : _b.stockAvailable) < 1)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    color: "error",
                    label: "",
                    size: "x-large"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                            start: "",
                            icon: "$info"
                        }),
                        _cache[1] || (_cache[1] = _createTextVNode(" Ausverkauft ", -1))
                    ]),
                    _: 1
                }))
                : (((_c = _ctx.currentProduct) === null || _c === void 0 ? void 0 : _c.stockAvailable) < 8)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Nur noch " + _toDisplayString((_d = _ctx.currentProduct) === null || _d === void 0 ? void 0 : _d.stockAvailable) + " St. vorrätig ", 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_7, "Auf Lager – sofort lieferbar"))
        ])
    ]));
}
